/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReportDateRange,
    ReportDateRangeFromJSON,
    ReportDateRangeFromJSONTyped,
    ReportDateRangeToJSON,
    ReportType,
    ReportTypeFromJSON,
    ReportTypeFromJSONTyped,
    ReportTypeToJSON,
    ReportingTimeBucket,
    ReportingTimeBucketFromJSON,
    ReportingTimeBucketFromJSONTyped,
    ReportingTimeBucketToJSON,
} from './';

/**
 * 
 * @export
 * @interface RunReportRequest
 */
export interface RunReportRequest {
    /**
     * 
     * @type {ReportingTimeBucket}
     * @memberof RunReportRequest
     */
    reportingTimeBucket?: ReportingTimeBucket;
    /**
     * 
     * @type {ReportType}
     * @memberof RunReportRequest
     */
    reportType?: ReportType;
    /**
     * 
     * @type {ReportDateRange}
     * @memberof RunReportRequest
     */
    reportDateRange?: ReportDateRange;
}

export function RunReportRequestFromJSON(json: any): RunReportRequest {
    return RunReportRequestFromJSONTyped(json, false);
}

export function RunReportRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunReportRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'reportingTimeBucket': !exists(json, 'reportingTimeBucket') ? undefined : ReportingTimeBucketFromJSON(json['reportingTimeBucket']),
        'reportType': !exists(json, 'reportType') ? undefined : ReportTypeFromJSON(json['reportType']),
        'reportDateRange': !exists(json, 'reportDateRange') ? undefined : ReportDateRangeFromJSON(json['reportDateRange']),
    };
}

export function RunReportRequestToJSON(value?: RunReportRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'reportingTimeBucket': ReportingTimeBucketToJSON(value.reportingTimeBucket),
        'reportType': ReportTypeToJSON(value.reportType),
        'reportDateRange': ReportDateRangeToJSON(value.reportDateRange),
    };
}


